import React from 'react';

import { FlagsProvider } from '@atlaskit/flag';

import type { BulkImportFeedbackService } from '../useBulkImportFeedbackService';
import { FeedbackModal } from '../../FeedbackModal/FeedbackModal';

interface WhiteboardBulkImportFeedbackModalProps {
	bulkImportFeedbackService: BulkImportFeedbackService;
	contentId: string;
	importSource?: string;
	importDate?: Date;
}

/**
 * Wrapper for the import feedback modal for use in Confluence Whiteboards. Relies on a service object to expose via the WhiteboardBridgeAPI
 * allowing for interfacing between Confluence Frontend and Canvas (Whiteboards).
 *
 * @param bulkImportFeedbackService - The ~stateful~ bulk import feedback service object which is registered in the WhiteboardBridgeAPI.
 */
export const WhiteboardBulkImportFeedbackModal = ({
	bulkImportFeedbackService,
	contentId,
	importSource,
	importDate,
}: WhiteboardBulkImportFeedbackModalProps) => {
	if (!importSource || !importDate) {
		return null;
	}

	return (
		<FlagsProvider>
			<FeedbackModal
				isOpen={bulkImportFeedbackService.isFeedbackModalOpen}
				closeModal={() => bulkImportFeedbackService.closeFeedbackModal()}
				importSource={importSource}
				importDate={importDate}
				contentId={contentId}
				// TODO(@rwang8): Implement feedback submission callback across bridge, see CCIMPORTER-477
				onFeedbackSubmit={() => {}}
			/>
		</FlagsProvider>
	);
};
